import { Component, OnInit } from '@angular/core';
import { Course } from '../../models/course';
import { CourseService } from '../../services/course.service';

@Component({
  selector: 'app-courses-block',
  templateUrl: './courses-block.component.html',
  styleUrls: ['./courses-block.component.scss']
})
export class CoursesBlockComponent implements OnInit {
  courses: Course[] = [];
  recommendedCourses: Course[] = [];
  latestCourses: Course[] = [];

  constructor(private coursesService: CourseService) {
  }

  ngOnInit(): void {
    this.coursesService.getCourses().then(res => {
      this.courses = Object.assign([], res);
      this.recommendedCourses = [...res].reverse();
      this.latestCourses = res;
      this.latestCourses.sort(function (a, b) {
        const first = new Date(b.createdAt);
        const second = new Date(a.createdAt);

        return first > second ? 1 : -1;
      });
      console.log(this.courses);
      console.log(this.recommendedCourses);
    });
  }


}
